/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamBreakdownService
 */

export const submitRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExamBreakdownService',
  rpcName: 'submit',
  auth: 'app',
  fingerprint: 'SgXzniJfwATOuBvFDwBEImam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};